import { render } from "./DRadioGroup.vue?vue&type=template&id=fb02ace6"
import script from "./DRadioGroup.vue?vue&type=script&lang=js"
export * from "./DRadioGroup.vue?vue&type=script&lang=js"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__